<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('setting.sex_place') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <div class="km-sec-head">Select your gender</div>
        <div class="km-card">
          <button class="km-row" :class="{ active: String(radio) === '1' }" @click="chooesSex(1)">
            <span class="km-row__ico" style="background:linear-gradient(135deg,#60a5fa,#3b82f6)">♂️</span>
            <span class="km-row__lbl">{{ $t('setting.man') }}</span>
            <span class="km-row__radio"></span>
          </button>
          <button class="km-row" :class="{ active: String(radio) === '2' }" @click="chooesSex(2)">
            <span class="km-row__ico" style="background:linear-gradient(135deg,#ff6b9d,#ff4d8d)">♀️</span>
            <span class="km-row__lbl">{{ $t('setting.female') }}</span>
            <span class="km-row__radio"></span>
          </button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() { return { radio: "", userInfo: {} }; },
  methods: {
    back() { return window.history.back(); },
    chooesSex(sex) {
      this.$http({ method: 'post', data: { sex: sex }, url: 'user_set_sex' }).then(res => {
        if (res.code === 200) { this.getUserInfo(); this.radio = sex; this.$toast(res.msg); }
        else if (res.code === 401) { this.$toast(res.msg); }
      });
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info', headers: { lang: window.localStorage.getItem("lang").toLowerCase() } })
        .then(res => {
          if (res.code === 200) { this.userInfo = res.data; this.radio = res.data.sex; }
          else if (res.code === 401) { this.$toast(res.msg); }
        });
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else this.getUserInfo();
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";
</style>
